import types from '../actions/accessManagementActionsTypes';

const INITIAL_STATE = {
    isPartnersLoading: false,
    selectedPartner: {},
    searchPartner: "",
    showPartners: true,
    showUsers: false,
    showUser: false,
    selectedUser: {},
    editApplication: false,
    searchUser: "",
    filterApplication: {},
    filterDepartment: {},
    showUserModal: false,
    modeUserModal: null,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.ACCESS_MANAGEMENT_SET_PARTNERS_LOADING:
            return { ...state, isPartnersLoading: action.payload };

        case types.ACCESS_MANAGEMENT_SET_SELECTED_PARTNER:
            return { ...state, selectedPartner: action.payload };

        case types.ACCESS_MANAGEMENT_SET_SEARCH_PARTNER:
            return { ...state, searchPartner: action.payload };

        case types.ACCESS_MANAGEMENT_SET_SHOW_PARTNERS:
            return { ...state, showPartners: action.payload };

        case types.ACCESS_MANAGEMENT_SET_SHOW_USERS:
            return { ...state, showUsers: action.payload };

        case types.ACCESS_MANAGEMENT_SET_SHOW_USER:
            return { ...state, showUser: action.payload };

        case types.ACCESS_MANAGEMENT_SET_SELECTED_USER:
            return { ...state, selectedUser: action.payload };

        case types.ACCESS_MANAGEMENT_EDIT_APPLICATION:
            return { ...state, editApplication: action.payload };

        case types.ACCESS_MANAGEMENT_SET_SEARCH_USER:
            return { ...state, searchUser: action.payload };

        case types.ACCESS_MANAGEMENT_SET_FILTER_APPLICATION:
            return { ...state, filterApplication: action.payload };

        case types.ACCESS_MANAGEMENT_SET_FILTER_DEPARTMENT:
            return { ...state, filterDepartment: action.payload };

        case types.ACCESS_MANAGEMENT_SET_SHOW_USER_MODAL:
            return { ...state, showUserModal: action.payload };

        case types.ACCESS_MANAGEMENT_SET_MODE_USER_MODAL:
            return { ...state, modeUserModal: action.payload };

        case types.ACCESS_MANAGEMENT_RESET_STATE:
            return INITIAL_STATE;

        default:
            return state;
    }
};
